import { useTranslation } from 'react-i18next'
import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { formatMoney } from './ItemConfiguration'
import type { CashReportLine } from './cashClosingFormatter'

function Row({ label, cents, value, total, indent }: { label: string; cents: number; value?: string; total: boolean; indent?: boolean }) {
  const { i18n } = useTranslation('posOrdering')
  return <p className={cn('flex justify-between gap-2', total && 'text-[15px] font-semibold')}><span className={cn('min-w-0', indent && 'ps-[2ch]')}>{label}</span>
    <span className="shrink-0">{value ?? formatMoney(i18n.language, cents / 100, 'EUR')}</span></p>
}
/** The printed bon on screen: same lines, same order as on paper. */
export function CashReceipt({ lines, header }: { lines: CashReportLine[]; header?: ReactNode }) {
  return <div className="shrink-0 drop-shadow-lg"><div className="pos-receipt" role="document">{header}{lines.map((line, i) => {
    switch (line.kind) {
      case 'title': return <p key={i} className={cn('text-center font-semibold', line.big ? 'text-lg leading-snug' : 'text-[15px]')}>{line.text}</p>
      case 'center': return <p key={i} className="text-center">{line.text}</p>
      case 'heading': return <p key={i} className="mt-0.5 font-semibold">{line.text}</p>
      case 'note': return <p key={i} className="break-words">{line.text}</p>
      case 'reason': return <p key={i} className="ps-[2ch] text-neutral-600">{line.text}</p>
      case 'small': return <p key={i} className="text-center text-[10px] text-neutral-500">{line.text}</p>
      case 'rule': return <hr key={i} className="my-2 border-t border-dashed border-neutral-400" />
      case 'grid': return <p key={i} className="grid grid-cols-4 gap-1 text-end [&>span:first-child]:text-start">{line.cells.map((cell, k) => <span key={k}>{cell}</span>)}</p>
      default: return <Row key={i} label={line.label} cents={line.cents} value={line.value} total={line.kind === 'total'} indent={line.indent} />
    }
  })}</div></div>
}
